export default __webpack_public_path__ + "static/media/hht2_ep5_speaking_04.2533685d.png";